<template>
  <div class="com_list_06">
    <div class="name" :title="objk.title" v-text="objk.title"></div>
    <slot v-bind:data="objk"></slot>
    <div class="state" v-html="checkType(objk)"></div>
    <div class="weight">排序权重：<b class="num" v-text="objk.sort"></b></div>
    <div class="more">
      <span class="more-dot">...</span>
      <ol>
        <li
          v-for="(el, index) in opList"
          :key="index"
          @click="el.clickFn ? el.clickFn(objk) : ''"
        >
          {{ el.label }}
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    objk: Object,
    moreBtn: Object,
  },
  computed: {
    opList() {
      let arr = this.moreBtn.list || [];
      if (this.moreBtn.backFn) {
        arr = this.moreBtn.backFn(this.objk);
      }
      return arr;
    },
  },
  methods: {
    checkType(da) {
      let maf = {
        1: { label: "上线", cls: "ys_001" },
        0: { label: "待上线", cls: "ys_002" },
        "-1": { label: "下线", cls: "ys_003" },
      };

      let str = `<span class="${maf[da.status].cls}">${
        maf[da.status].label
      }</span>`;

      str += `<br/><span class="oufsd">${da.start_time || ""}<br/>${
        da.end_time || ""
      }</span>`;

      return str;
    },
  },
};
</script>
<style lang='scss'>
.com_list_06 {
  display: inline-block;
  vertical-align: top;
  position: relative;
  padding: 15px;
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .layout {
    width: 135px;
    height: 75px;
  }
  .state {
    margin-top: 10px;
  }
  .weight {
    margin-top: 10px;
    color: #979797;
  }
  .more {
    position: absolute;
    top: 0;
    right: -22px;
    z-index: 9;
    padding-right: 36px;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    .more-dot {
      color: #999;
    }
    ol {
      display: none;
      position: absolute;
      right: -90px;
      top: 0;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #d8d8d8;
      li {
        width: 100px;
        height: 36px;
        line-height: 36px;
        margin: 0;
        padding: 0;
        text-indent: 10px;
        color: #999;
        font-size: 12px;
        border: none;
        &:hover {
          background-color: #e8e8e8;
        }
      }
    }
    &:hover {
      ol {
        display: block;
      }
    }
  }
}
span.oufsd {
  display: block;
  height: 40px;
}
</style>